module.exports = __webpack_public_path__ + "media/not_used_touchdown.75699d49.webm";